import { Navigate, type RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// Phase H (H-E pensions). P2-4 (BUG-31, A10): the settings page is Payroll → Pensions, so payroll
// roles reach it without Settings access. The old Settings address redirects for bookmarks.
export const payrollRoutes: RouteObject[] = [{ path: 'pensions', lazy: page(() => import('./settings-page'), (m) => m.PensionSettingsPage) }];
export const settingsRoutes: RouteObject[] = [{ path: 'payroll-pensions', element: <Navigate to="/payroll/pensions" replace /> }];
